export const userInputs = [
  {
    id: "username",
    label: "Nazwa użytkownika",
    type: "text",
    placeholder: "john_doe",
  },
  {
    id: "email", 
    label: "Email",
    type: "email",
    placeholder: "john_doe@gmail.com",
  },
  {
    id: "firstName", 
    label: "Imię",
    type: "text",
    placeholder: "Jan",
  },
  {
    id: "lastName", 
    label: "Naziwsko",
    type: "text",
    placeholder: "Kowalski",
  },
  {
    id: "phone",
    label: "Telefon",
    type: "text",
    placeholder: "+1 234 567 89",
  },
  {
    id: "password",
    label: "Hasło",
    type: "password",
  },
  {
    id: "street",
    label: "Ulica",
    type: "text",
    placeholder: "os. Konstytucji 3 Maja",
  },
  {
    id: "homeNumber",
    label: "Numer domu",
    type: "text",
    placeholder: "13/11",
  },
  {
    id: "city",
    label: "Miasto",
    type: "text",
    placeholder: "Kościan",
  },
];

export const productInputs = [
  {
    id: "name",
    label: "Nazwa",
    type: "text",
    placeholder: "Margherita",
  },
  {
    id: "desc",
    label: "Opis",
    type: "text",
    placeholder: "delikatna pizza z sosem pomidorowym skąpana bazylią",
  },
];

export const orderInputs = [
  {
    id: "customerId",
    label: "Numer klienta",
    type: "text",
    placeholder: "ID klienta",
  },
  {
    id: "phone",
    label: "Numer telefonu",
    type: "number",
    placeholder: "515682850",
  },
  {
    id: "firstName",
    label: "Imię",
    type: "text",
    placeholder: "Jan",
  }, 
  {
    id: "lastName",
    label: "Nazwisko",
    type: "text",
    placeholder: "Kowalski",
  },
  {
    id: "street",
    label: "Ulica",
    type: "text",
    placeholder: "Poznańska",
  },
  {
    id: "homeNumber",
    label: "Numer domu",
    type: "text",
    placeholder: "13/11",
  },
  {
    id: "city",
    label: "Miasto",
    type: "text",
    placeholder: "Kościan",
  },
];

export const employeeInputs = [
  {
    id: "firstName",
    label: "Imię",
    type: "text",
    placeholder: "Jan",
  },
  {
    id: "lastName",
    label: "Nazwisko",
    type: "text",
    placeholder: "Kowalski",
  },
  {
    id: "phone",
    label: "Telefon",
    type: "text",
    placeholder: "+1 234 567 89",
  },
  {
    id: "salary",
    label: "Stawka",
    type: "text",
    placeholder: "23.50",
  },
  {
    id: "allowed",
    label: "Książeczka",
    type: "text",
    placeholder: "03/2025",
  },
];

export const ingredientInputs = [
  {
    id: "name",
    label: "Nazwa",
    type: "text",
    placeholder: "nazwa",
  },
];

export const voucherInputs = [
  {
    id: "name",
    label: "Kod",
    type: "text",
    placeholder: "kod",
  },
  {
    id: "value",
    label: "Wartość kodu",
    type: "number",
    placeholder: "10",
  },
  {
    id: "quantity",
    label: "Ilość",
    type: "number",
    placeholder: "1",
  }
];
